import React from "react"
import SearchResult from "./SearchResult"
import SearchHeader from "./SearchHeader"
import SearchSort from "./SearchSort"
import SearchTitle from "./SearchTitle"
import SearchPagination from "./SearchPagination"

export default class SearchResults extends React.Component {
	
	constructor(props) {
		super(props);

		this.state = {
			resultOverlay: null,
			loading: false,
			page: typeof this.props.page !== 'undefined' ? parseInt(this.props.page) : 1,
			sort: this.props.sort || 'relevance',
			size: this.props.size || 'large'
		}

		this.onShowResultOverlay = this.onShowResultOverlay.bind(this);
		this.onChangePage = this.onChangePage.bind(this);
		this.onChangeSort = this.onChangeSort.bind(this);
		this.setLoading = this.setLoading.bind(this);
	}

	render() {
		var self = this;
		var results = this.props.search_results.map((search_result) => {
			return <SearchResult locations_used={self.props.locations_used} account_course_collections={self.props.course_collections} {...search_result} resultOverlay={self.state.resultOverlay} key={search_result.id} size={self.state.size} onShowResultOverlay={self.onShowResultOverlay} />
		})

		return (
			<div className="search-results">
				<SearchHeader {...this.props} {...this.state} setLoading={this.setLoading} />
				<SearchSort   {...this.props} {...this.state} onChangeSort={this.onChangeSort} />
				<SearchTitle  {...this.props} size={this.state.size} />
				{results}
				<SearchPagination {...this.props} {...this.state} onChangePage={this.onChangePage} />
				{this.state.loading ? <div className="loadingOverlay"><div className="spinner"></div></div> : null}
			</div>
		)
	}

	onChangePage(page, active) {
		if (!active) {
			if (page <= 0) {
				page = 1
			}
			if (page > this.props.total_pages) {
				page = this.props.total_pages
			}
			this.setState({page: page});
		}
	}

	onChangeSort(sort) {
		this.setState({sort: sort});
	}

	onShowResultOverlay(result) {
		this.setState({resultOverlay: result});
	}

	setLoading(loading) {
		this.setState({loading: loading});
	}

}